const isSpaceForText = (d) => {
  for (let child of d.children) {
    if (child.y0 - d.y0 < 15) return false;
  }
  return true;
};

export default isSpaceForText;
